import { validatorTypes } from '@data-driven-forms/react-form-renderer';
import moment from 'moment';

const zepto3plFieldMap = {
  fields: [
    {
      component: 'radio',
      label: 'What kind of vehicle do you have?',
      name: 'vehicleType',
      options: [
        {
          label: 'Cycle',
          value: 'Cycle',
        },
        {
          label: 'Electric Bike/Electric Scooter',
          value: 'Electric Bike',
        },
        {
          label: 'Petrol Bike/Petrol Scooter',
          value: 'Petrol Bike',
        },
      ],
      isRequired: true,
      validate: [
        {
          type: 'required',
        },
      ],
    },
    {
        component: 'text-field',
        name: 'vehicleNumber',
        label: 'Vehicle Number',
        isRequired: true,
        validate: [
          {
            type: 'required',
          },
        ],
        placeholder: 'MH12AC3214',
        condition: {
          when: 'vehicleType',
          is: 'Petrol Bike',
          then: {
            visible: true,
          },
          else: {
            visible: false
          }
        }
      }
  ],
};

export default zepto3plFieldMap;
